<template>
  <div class="modal" data-backdrop="static" data-keyboard="false" id="add_waiter" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="resetWaiter"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" id="assign_table_modalLabel">Add New Waiter</h4>
        </div>
        <form @submit.prevent="addNewWaiter">
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <label>Waiter Name</label>
                  <input
                      v-model="waiterName"
                      type="text"
                      class="form-control"
                      required="required"
                      placeholder="Enter Name...">
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col-md-12">
                <button type="submit" class="btn btn-success pull-right">Add Waiter</button>
              </div>
            </div>
            <br/>
          </div>
        </form>
        <table class="table table-bordered table-hover table-stripped">
          <thead>
          <tr>
            <th class="text-center">ID</th>
            <th class="text-center">Waiter Name</th>
            <th class="text-center"><i class="fa fa-bolt"></i></th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(waiter, waiterIndex) in filteredWaiters">
            <tr :key="waiterIndex + '_' + waiter.id" v-if="!waiter.deleted">
              <td class="text-center">{{waiter.id}}</td>
              <td class="text-center">{{waiter.name}}</td>
              <th class="text-center"><button @click="deleteWaiter(waiter.id)" class="btn btn-danger btn-md"><i class="fa fa-times"></i></button></th>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</template>

<script>
import {addNewWaiter, fetchTablesOfBranch, fetchWaitersOfBranch} from "@/api/pos";

export default {
  name: "AddNewWaiter",
  data(){
    return {
      waiterName: '',
      waiter: {
        "id": 0,
        "name": "",
      }
    }
  },
  computed: {
    filteredWaiters () {
      const filterWaiters = this.tables
          .filter(table => table.orderObject !== null) // Filter out tables without orderObject
          .map(table => JSON.parse(table.orderObject).waiter);
      console.log(filterWaiters)
      return this.waiters.filter(waiter => {
        // Check if the waiter's id is not present in filterWaiters
        return !filterWaiters.some(filteredWaiter => filteredWaiter && filteredWaiter.id === waiter.id);
      })
      // console.log(waiterIds);
    }
  },
  props : ['selectedBranch', 'waiters', 'tables'],
  methods: {
    load () {
      $("#add_waiter").modal("show");
      this.fetchTables();
      // const filterWaiters = this.tables
      //     .filter(table => table.orderObject !== null) // Filter out tables without orderObject
      //     .map(table => JSON.parse(table.orderObject).waiter);
      // console.log(filterWaiters)
    },
    fetchTables: async function() {
      let param = new URLSearchParams();
      param.append("branch_id", this.selectedBranch.id);
      const {data} = await fetchTablesOfBranch(param)
      this.$emit('updatedTableList', data)
    },

    async addNewWaiter() {
      try {
        this.waiter.name = this.waiterName
        this.waiter.branch = this.selectedBranch
        await addNewWaiter(this.waiter)
        await this.fetchWaiters()
      } catch (e) {
        this.showErrorMessage(e)
      }
      this.resetWaiter()
      $("#add_waiter").modal("hide");
    },
    resetWaiter() {
      this.waiterName = ''
    },

    deleteWaiter: function(waiterId) {
      Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to delete this Waiter?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete'
      }).then(async result => {
        if (result.value) {
          this.$http.delete(this.$store.state.mainAppURL + "waiters/" + waiterId).then(async resp => {
            Swal.close();
            await this.fetchWaiters()
            Swal("Deleted", "Waiter Has Been Deleted", "success");
          })
        }
      });
    },

    async fetchWaiters() {
      let param = new URLSearchParams();
      param.append("branch_id", this.selectedBranch.id);
      const {data} = await fetchWaitersOfBranch(param)
      this.$emit('updatedWaiterList', data)
    },
  }
}
</script>

<style scoped>

</style>